const languageSwitch = document.querySelector('.js-language-switch');

if (languageSwitch) {
  languageSwitch.addEventListener('change', (e) => {
    window.location.href = e.target.value;
  });
}
